import * as React from "react";
import Component from "../../AbstractComponent";

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
// import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';

export class LeavePromptDialog extends Component {

  private prioritizeClosing: boolean = false;
  private title: string = this.trans("discard-changes");
  private content: string = this.trans("warning-data-may-be-lost");
  private relyOnProps: boolean = false;

  constructor(public props) {
    super(props);

    if (typeof this.props.prioritizeClosing !== "undefined") {
      this.prioritizeClosing = this.props.prioritizeClosing;
    }

    if (typeof this.props.title !== "undefined") {
      this.title = this.props.title;
    }

    if (typeof this.props.content !== "undefined") {
      this.relyOnProps = true;
      this.content = this.props.content;
    }

    this.close = this.close.bind(this);
    this.discard = this.discard.bind(this);
    this.save = this.save.bind(this);
  }

  public discard(): void {
    if (typeof this.props.onDiscard !== "undefined") {
      this.props.onDiscard.call(this);
    }
  }

  public save(): any {
    if (typeof this.props.onSave !== "undefined") {
      this.props.onSave.call(this);
    }
  }

  public close(): void {
    if (typeof this.props.onClose !== "undefined") {
      return this.props.onClose.call(this);
    }

    if (typeof this.props.onDiscard !== "undefined") {
      return this.props.onDiscard.call(this);
    }
  }

  public renderContent(): any {
    if (this.relyOnProps === true) {
      return this.props.content;
    }

    return this.content;
  }

  public render() {
    return (
      <Dialog
        className={`dialog dialog-window leave-promt-dialog has-button-padding ${this.props.innerDialogClasses}`}
        open={this.props.openLeavePrompt}
        onClose={() => this.prioritizeClosing === false ? this.save() : this.close()}
        disableBackdropClick={true}
      >
        <DialogTitle>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              minHeight: "calc(24px + 2em)"
            }}>
            <h4>{this.props.customTitle || this.title}</h4>
            {
              this.props.subtitle && (
                <h6
                  style={{
                    fontWeight: "normal",
                    color: "rgb(137, 137, 137)",
                    margin: 0
                  }}>{this.props.subtitle}</h6>
              )
            }
          </div>
        </DialogTitle>
        <DialogContent>
          <div className="dialog-content-wrapper">
            {this.renderContent()}
          </div>
        </DialogContent>
        <DialogActions>
          <div className="dialog-buttons-wrapper">
            {
              !this.props.customButtons && (
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                  <div>
                    <Button
                      color="primary"
                      onClick={this.close}
                    >
                      {this.trans("button-cancel")}
                    </Button>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={this.discard}
                    >
                      {this.trans("button-discard")}
                    </Button>
                    {/* <Button
                    variant="contained"
                    color="primary"
                    onClick={this.save}
                  >
                    {this.trans("button-save")}
                  </Button> */}
                  </div>
                </div>
              )
            }

            {
              !!this.props.customButtons && this.props.customButtons
            }
          </div>
        </DialogActions>
      </Dialog>
    );
  }
}
